module.exports = __webpack_public_path__ + "static/media/floor.d01110bc.svg";